<template>
  <v-layout>
    <v-flex xs12 mt-2>
      <v-layout row wrap>
        <v-spacer></v-spacer>
        <div class="text-xs-center">
          <h4 class="primary--text font-weight-bold text-uppercase pt-1">Eventi in calendario</h4>
          <span v-if="!filtroEventi.isAnnuale" class="primary--text text-capitalize">{{ Util.getMonthName(mese) }}</span>
          <span v-if="filtroEventi.isAnnuale && !filtroEventi.AnnoSportivo" class="primary--text text-capitalize">{{ mese.getFullYear() }}</span>
          <span v-if="filtroEventi.AnnoSportivo" class="primary--text text-capitalize">{{ filtroEventi.AnnoSportivo.Descrizione }}</span>
        </div>
        <v-spacer></v-spacer>
        <v-tooltip left class="ml-4">
          <v-btn slot="activator" @click="refreshEvents(mese.getMonth())" flat icon>
            <v-icon>cached</v-icon>
          </v-btn>
          <span>Aggiorna</span>
        </v-tooltip>
      </v-layout>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 md3>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                  v-model="filtroEventi.AnnoSportivo"
                  :items="anniSportivi"
                  :label="filtroEventi.isGara === true ? 'Anno Sportivo' : 'Anno di riferimento'"
                  @change="filtraAnnoSez"
                  box
                  item-text="Descrizione"
                  return-object
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  v-model="filtroEventi.TipoEvento"
                  :items="tipiEvento"
                  @change="filtraTipoEvt"
                  item-text="Descrizione"
                  return-object
                  box
                  label="Tipo Evento"
                  clearable
                  hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  v-model="filtroEventi.Sezione"
                  :items="sezioni"
                  @change="filtraSez"
                  item-value="id"
                  item-text="Descrizione"
                  box
                  label="Regione"
                  clearable
                  hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex v-if="filtroEventi.isGara === true" xs12 md9>
                <v-autocomplete
                  v-model="filtroEventi.isIndoorOutdoor"
                  :items="inoutdoor"
                  @change="filtraTipoTag"
                  clerable
                  return-object
                  box
                  label="Indoor/Outdoor"
                  clearable
                  hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 ma-0 mt-3 pa-0>
                <v-layout>
                  <v-flex xs12 md3><h5 class="primary--text pa-1 pr-3">EVENTI</h5></v-flex>
                  <v-flex xs12 md3
                    ><h5 :class="filtroEventi.isGara === false ? 'textR font-weight-bold primary--text pa-1 pr-3' : 'textR font-weight-bold pa-1 pr-3'" style="color: #0000008a;">
                      Formativi Didattici
                    </h5></v-flex
                  >
                  <v-flex xs12 md5><v-switch v-model="filtroEventi.isGara" @change="filtraGaraForDida" class="switchEventi ma-0 mt-1 pa-0" label="Gare"></v-switch></v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 ma-0 mt-1 pa-0>
                <v-layout>
                  <v-flex xs12 md3><h5 class="text-uppercase primary--text pa-1 pr-3">Attivi</h5></v-flex>
                  <v-flex xs12 md3
                    ><h5 :class="filtroEventi.isAperti === false ? 'textR font-weight-bold primary--text pa-1 pr-3' : 'textR font-weight-bold pa-1 pr-3'" style="color: #0000008a;">
                      Tutti
                    </h5></v-flex
                  >
                  <v-flex xs12 md5><v-switch v-model="filtroEventi.isAperti" @change="filtraAperti" label="Correnti" class="switchEventi ma-0 mt-1 pa-0"></v-switch></v-flex>
                </v-layout>
              </v-flex>
              <v-flex v-if="isFiltroIscritto()" xs12 ma-0 mt-1 pa-0>
                <v-layout>
                  <v-flex xs12 md3>
                    <h5 class="text-uppercase primary--text pa-1 pr-3">iscrizione</h5>
                  </v-flex>
                  <v-flex xs12 md3>
                    <h5
                      :class="filtroEventi.isNotIscritto === false ? 'textR font-weight-bold primary--text pa-1 pr-3' : 'textR font-weight-bold pa-1 pr-3'"
                      style="color: #0000008a;"
                    >
                      Già iscritto
                    </h5>
                  </v-flex>
                  <v-flex xs12 md5><v-switch v-model="filtroEventi.isNotIscritto" @change="filtraIscritti" label="Tutti" class="switchEventi ma-0 mt-1 pa-0"></v-switch> </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 ma-0 mt-1 pa-0>
                <v-layout>
                  <v-flex xs12 md3><h5 class="text-uppercase primary--text pa-1 pr-3">Calendario</h5></v-flex>
                  <v-flex xs12 md3>
                    <h5 :class="filtroEventi.isAnnuale === false ? 'textR font-weight-bold primary--text pa-1 pr-3' : 'textR font-weight-bold pa-1 pr-3'" style="color: #0000008a;">
                      Mensile
                    </h5></v-flex
                  >
                  <v-flex xs12 md5
                    ><v-switch
                      v-model="filtroEventi.isAnnuale"
                      @change="filtraAnnuale"
                      :label="filtroEventi.AnnoSportivo.Descrizione"
                      class="switchEventi ma-0 mt-1 pa-0"
                    ></v-switch
                  ></v-flex>
                </v-layout>
              </v-flex>

              <v-flex v-if="userData.tipoAccesso && userData.tipoAccesso == 'WEB'" xs12>
                <v-btn v-if="isIscrittoFederazione()" @click="downloadCsainPass()" flat> <v-icon left>card_membership</v-icon>Scarica il Pass CSAIN </v-btn>
              </v-flex>
              <!--
                <v-flex v-if="showPass()" xs12>
                  <v-btn v-if="isIscrittoFederazione()" @click="downloadCampionatoPass()" flat> <v-icon left>file_download</v-icon>Pass competizione nazionale </v-btn>
                </v-flex>
              -->
              <v-flex v-if="!filtroEventi.isAnnuale" xs12>
                <functional-calendar
                  ref="Calendar"
                  v-model="calendar"
                  :marked-dates="markedDates"
                  :sunday-start="false"
                  :day-names="['Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa', 'Do']"
                  :month-names="['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']"
                  :apply-stylesheet="false"
                  @changedMonth="changedMonth"
                ></functional-calendar>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md9>
            <v-layout row wrap>
              <v-flex v-for="evt in paginatedData" :key="evt.id" xs12 md6 lg4 pa-2>
                <v-card elevation-4>
                  <v-layout class="event-card">
                    <v-flex xs4 pt-3 pl-3 pr-0>
                      <v-img :src="'/eventi/' + evt.TipoEventoCodice + (evt.isOpen ? '_OPEN' : '') + '.jpg'" aspect-ratio="1"></v-img>
                    </v-flex>
                    <v-flex xs8>
                      <v-card-title class="py-0">
                        <div>
                          <v-tooltip
                            v-if="evt.IsIscritto"
                            :class="{
                              red: evt.StatoIscrizione == 'ListaAttesa' || evt.StatoIscrizione == 'Sospeso',
                              green: evt.StatoIscrizione == 'Iscritto',
                              purple: evt.StatoIscrizione == 'Pagato' || evt.StatoIscrizione == 'Confermato',
                              blue: evt.StatoIscrizione == 'Prenotato',
                              brown: evt.StatoIscrizione == 'Annullato',
                            }"
                            top
                            class="label-iscritto"
                          >
                            <div slot="activator">
                              <v-icon small color="white">star</v-icon>
                            </div>
                            <span>{{ evt.StatoIscrizione }}</span>
                          </v-tooltip>
                          <div class="text-xm-left">
                            <small v-text="evt.SezioneDescrizione"></small>
                          </div>
                          <div v-text="evt.TitoloEvento" class="subheading primary--text font-weight-bold text-xs-left"></div>
                          <div class="text-xs-left">{{ Util.formattaData(evt.DataEvento) }}</div>
                          <div class="text-xs-left">{{ evt.CittaIndirizzo }}</div>
                          <div>
                            <small v-text="evt.AssociazioneDenominazione" class="text-xs-left accent--text"></small>
                          </div>

                          <div v-if="evt.TipologiaEvento === 'Formazione' || evt.TipologiaEvento === 'Didattico'">
                            <v-chip v-if="evt.Classificati == 0" small color="secondary darken-1 ml-0" text-color="white">
                              <v-avatar class="secondary darken-3">{{ evt.TotalePartecipanti }}</v-avatar
                              >Totale Partecipanti
                            </v-chip>
                            <span v-else>
                              <v-icon left color="primary">fa-trophy</v-icon>
                            </span>
                            <v-avatar v-if="evt.TipologiaEvento === 'Formazione'" size="24" color="purple" small>
                              <span class="white--text xm">F</span>
                            </v-avatar>
                            <v-avatar v-else-if="evt.TipologiaEvento === 'Didattico'" size="24" color="orange" small>
                              <span class="white--text xm">D</span>
                            </v-avatar>
                          </div>

                          <div v-else>
                            <v-chip v-if="evt.Classificati == 0" small color="secondary darken-1 ml-0" text-color="white">
                              <v-avatar class="secondary darken-3">{{ evt.TotalePartecipanti }}</v-avatar
                              >Totale Partecipanti
                            </v-chip>
                            <v-avatar v-else>
                              <span>
                                <v-icon color="primary">fa-trophy</v-icon>
                              </span>
                            </v-avatar>
                            <v-avatar v-if="evt.isOpen" size="24" color="blue" small>
                              <span class="white--text xm">O</span>
                            </v-avatar>
                            <v-avatar v-else size="24" color="red" small>
                              <span class="white--text xm">U</span>
                            </v-avatar>
                          </div>
                          <div>
                            <v-chip v-if="evt.StatoEvento === 'Chiuso'" small color="orange" class="ml-0">Evento chiuso</v-chip>
                          </div>
                        </div>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-card-actions class="grey lighten-4">
                    <v-btn
                      v-if="showIscrivi(evt) && evt.StatoEvento != 'Chiuso'"
                      @click="$router.push({ name: 'eventi/calendario/iscrizioni', params: { idEvento: evt.id ,idAnnoSportivo: evt.AnnoSportivoId} })"
                      flat
                      color="amber darken-3"
                      >Iscrivi</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn @click="showDettaglioDialog(evt)" flat color="accent">Dettagli</v-btn>

                    <v-btn slot="activator" v-if="showPrenota(evt) && evt.StatoEvento != 'Chiuso'" @click="showPrenotazioneDialog(evt)" color="primary" small>Prenota</v-btn>
                    <v-btn
                      v-else-if="
                        showAnnulla(evt) &&
                        evt.StatoEvento != 'Chiuso' &&
                        evt.abilitatoPrenotazione &&
                        evt.IsIscritto &&
                        checkFunzione(elencoFunzioni.CANCELLAZIONE_PRENOTAZIONE_EVENTO) &&
                        evt.StatoIscrizione == 'Prenotato'
                      "
                      @click="dialogAnnullamenoOpen(evt, 0)"
                      color="red white--text"
                      small
                      flat
                      >Annulla Prenotazione</v-btn
                    >
                    <v-btn
                      v-else-if="
                        evt.StatoEvento != 'Chiuso' &&
                        showAnnulla(evt) &&
                        evt.abilitatoPrenotazione &&
                        evt.IsIscritto &&
                        checkFunzione(elencoFunzioni.CANCELLAZIONE_PRENOTAZIONE_EVENTO) &&
                        evt.StatoIscrizione == 'Iscritto'
                      "
                      @click="dialogAnnullamenoOpen(evt, 1)"
                      color="red white--text"
                      small
                      flat
                      >Annulla Iscrizione</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex v-if="!eventiMese.length" xs12 class="text-xs-center mt-4"> <v-icon class="mr-2" color="red">warning</v-icon>Nessun evento in programma </v-flex>

              <prenotazione-dialog
                :prop-evento-obj="eventoObj"
                :prop-iscrizione-obj="iscrizioneObj"
                :prop-partecipazioni="partecipazioni"
                :prop-status="prenotazioneDialog"
              ></prenotazione-dialog>

              <dettaglio-dialog
                :prop-evento-obj="eventoObj"
                :prop-iscrizione-obj="iscrizioneObj"
                :prop-image="image"
                :prop-status="dettaglioDialog"
                :prop-lista-associati="false"

              ></dettaglio-dialog>

              <v-dialog v-model="dialogAnnullameno" persistent max-width="490">
                <v-card>
                  <v-card-title class="display-1 font-weight-bold red white--text">Annullamento {{ annullaItem }}</v-card-title>
                  <v-card-text class="headline">Sei sicuro di voler annullare {{ annullaText }}?</v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialogAnnullameno = false" color="red white--text" class="btnDefault" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
                    <v-btn @click="annullaPrenotazione(eventoObj)" color="green white--text" dark> <v-icon small left>check</v-icon>si</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>
            <div class="text-xs-center">
              <v-pagination v-if="eventiMese.length > 9" v-model="page" :length="Math.ceil(eventiMese.length / 9)"></v-pagination>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex';
  import { FunctionalCalendar } from 'vue-functional-calendar';
  import EventoEntity from './generale/EventoEntity';
  import PartecipazioneEntity from './generale/PartecipazioneEntity';
  import PartecipazioneVM from './generale/PartecipazioneVM';
  import PrenotazioneDialog from './PrenotazioneDialog';
  import DettaglioDialog from './DettaglioDialog';
  import FiltroEvento from './generale/FiltroEvento';
  import Util from '@/util';
  import { bus } from '@/main';
  import Security from '@/security';
  import * as moment from 'moment';
  import 'moment/locale/it';
  import store from '@/store/store';

  export default {
    components: {
      FunctionalCalendar,
      PrenotazioneDialog,
      DettaglioDialog,
    },
    data: () => ({
      Util,
      elencoFunzioni: Security.enFunzione,
      ruoliUtente: Security.ruolo,
      prenotazioneDialog: false,
      dettaglioDialog: false,
      dialogAnnullameno: false,
      calendar: {},
      markedDates: [],
      eventiMese: [],
      mese: new Date(),
      tipoEvtSelezionato: null,
      sezSelezionata: null,
      imageMimeType: null,
      eventoObj: new EventoEntity(),
      partecipazioneObj: new PartecipazioneEntity(),
      iscrizioneObj: new PartecipazioneVM(),
      inoutdoor: ['Indoor', 'Outdoor'],
      page: 1,
      iscrittoCompetizione: false,
      annullaItem: '',
      annullaText: '',
    }),

    computed: {
      ...mapGetters('eventiModule', ['getEventiView', 'getEvento', 'getImage', 'getPartecipazione', 'getPartecipazioniView', 'getFiltroEventiHome', 'getEventoSpeciale']),
      ...mapGetters('sharedModule', ['getSezioni', 'getCategorieEvento', 'getCategorieEventoEuropeo', 'getTipiEvento', 'getAnniSportivi']),
      ...mapGetters(['userData']),

      filtroEventi() {
        return this.getFiltroEventiHome;
      },
      eventi() {
        return this.getEventiView;
      },
      evento() {
        return this.getEvento;
      },
      eventoSpeciale() {
        return this.getEventoSpeciale;
      },
      partecipazione() {
        return this.getPartecipazione(1);
      },
      partecipazioni() {
        return this.getPartecipazioniView;
      },
      sezioni() {
        return this.getSezioni;
      },

      tipiEvento() {
        const vm = this;
        if (this.filtroEventi.isGara === true) {
          return this.getTipiEvento.filter((t) => t.Codice != 'DIDA' && t.Codice != 'FOR');
        } else {
          return this.getTipiEvento.filter((t) => t.Codice === 'DIDA' || t.Codice === 'FOR');
        }
      },
      categorie() {
        return this.getCategorieEvento.filter((p) => {
          return p.Codice != 'FO' && p.Codice != 'DI';
        });
      },
      categorieEuropeo() {
        return this.getCategorieEventoEuropeo;
      },
      anniSportivi() {
        return this.getAnniSportivi;
      },
      isIscrittoCampionatoNazionale() {
        this.partecipazioni.forEach((element) => {
          if (element.iscrittoId == this.userData.id) {
            this.iscrittoCompetizione = true;
          }
        });
        return this.iscrittoCompetizione;
      },
      image() {
        return this.getImage;
      },
      paginatedData: {
        get() {
          const start = (this.page - 1) * 9;
          const end = start + 9;
          return this.eventiMese.slice(start, end);
        },
        set(newValue) {
          return newValue;
        },
      },
    },

    watch: {
      eventi() {
        const start = (this.page - 1) * 9;
        const end = start + 9;
        this.paginatedData = this.eventiMese.slice(start, end);
      },
    },

    created() {
      const vm = this;
      //vm.isIscrittoCampionatoNazionale();
      if (!this.filtroEventi) {
        const filtroDefault = new FiltroEvento();
        filtroDefault.AnnoSportivo = {
          id: 322,
          Codice: '20262027',
          Descrizione: '2026/2027',
          Tipo: 'AnnoSportivo',
          Tag: null,
        };
        this.saveFiltroEventiHome(filtroDefault);
      }
      this.refreshEvents();
      bus.$on('close-prenotazioneDialog', function (value) {
        if (value.update) {
          vm.refreshEvents(vm.mese.getMonth());
        }
        vm.prenotazioneDialog = false;
      });
      bus.$on('update-prenotazioneDialog', function (value) {
        vm.refreshEvents(vm.mese.getMonth());
        vm.prenotazioneDialog = false;
      });
      bus.$on('close-dettaglioDialog', function (value) {
        vm.dettaglioDialog = false;
      });

      bus.$on('open-prenotazioneDialog', function (evt) {
        vm.showPrenotazioneDialog(evt);
      });
    },

    methods: {
      ...mapActions('associatiModule', ['loadCsainPass', 'loadCampionatoPass']),
      ...mapActions('sharedModule', ['loadTipologie']),
      ...mapActions('eventiModule', [
        'loadEventiView',
        'loadEventiViewAdmin',
        'loadEvento',
        'loadImage',
        'loadPartecipazioniByIscritto',
        'loadPartecipazioni',
        'updatePartecipazione',
        'saveFiltroEventiHome',
        'existIscrizione',
      ]),
      refreshEvents(dataVisualizzato) {
        const vm = this;
        if (!this.dataCalendario) {
          this.dataCalendario = new Date();
          this.dataCalendario.setHours(0, 0, 0, 0);
        }
        if (dataVisualizzato) {
          moment(this.dataCalendario).set('month', dataVisualizzato);
        }

        this.saveFiltroEventiHome(this.filtroEventi);

        this.loadTipologie().then(() => {
          if (vm.userData.Role == vm.ruoliUtente.RESPONSABILE_ASSOCIAZIONE || vm.userData.Role == vm.ruoliUtente.ASSOCIATO) {
            vm.loadEventiView(this.filtroEventi.AnnoSportivo.id).then(() => {
              vm.eventi.forEach((evt) => {
                if (evt.isAttivo) {
                  vm.markedDates.push(new Date(evt.DataEvento).toLocaleString('it-IT', { month: 'numeric', day: 'numeric', year: 'numeric' }));
                }
              });
              if (vm.$refs.Calendar) {
                vm.$refs.Calendar.ChooseDate(new Date(vm.mese).toLocaleString('it-IT', { month: 'numeric', day: 'numeric', year: 'numeric' }));
              }
              this.eventiMese = this.filterEventi(this.mese, this.filtroEventi);
            });
          } else if (vm.userData.Role == vm.ruoliUtente.VIEWER || vm.userData.Role == vm.ruoliUtente.UTENTE || vm.userData.Role == vm.ruoliUtente.UTENTE_AMMINISTRATIVO) {
            vm.loadEventiViewAdmin(this.filtroEventi.AnnoSportivo.id).then(() => {
              vm.eventi.forEach((evt) => {
                if (evt.isAttivo) {
                  vm.markedDates.push(new Date(evt.DataEvento).toLocaleString('it-IT', { month: 'numeric', day: 'numeric', year: 'numeric' }));
                }
              });
              if (vm.$refs.Calendar) {
                vm.$refs.Calendar.ChooseDate(new Date(vm.mese).toLocaleString('it-IT', { month: 'numeric', day: 'numeric', year: 'numeric' }));
              }
              vm.eventiMese = vm.filterEventi(vm.mese, vm.filtroEventi);
            });
          }
        });
      },

      isAdmin() {
        if (this.userData.Role) {
          return this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO || this.userData.Role === this.ruoli.ADMIN;
        } else {
          return false;
        }
      },

      downloadFromWebview(url) {
        window.flutter_inappwebview.callHandler(
          'MobileDownload',
          JSON.stringify({
            urlToDownload: url,
          }),
        );
      },

      filterEventi(dataCalendario, filtro) {
        let eventiFiltrati = [];
        this.mese = new Date(dataCalendario);

        if (!filtro.isAnnuale) {
          eventiFiltrati = this.eventi.filter((e) => {
            const data = new Date(e.DataEvento);
            return data.getMonth() == this.mese.getMonth() && data.getFullYear() == this.mese.getFullYear();
          });
        } else if (!filtro.AnnoSportivo) {
          eventiFiltrati = this.eventi.filter((e) => {
            const data = new Date(e.DataEvento);
            return data.getFullYear() == this.mese.getFullYear();
          });
        } else {
          eventiFiltrati = this.eventi;
        }

        if (filtro.isGara) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.TipologiaEvento == 'Gara';
          });
        } else {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            if (this.userData.Role === 'UTENTE_AMMINISTRATIVO') {
              return e.TipologiaEvento != 'Gara';
            } else {
              return e.TipoEventoCodice === 'FOR' || (e.TipoEventoCodice === 'DIDA' && e.AssociazioneId == this.userData.AssociazioneId);
            }
          });
        }

        if (this.userData.Role == this.ruoliUtente.RESPONSABILE_ASSOCIAZIONE) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.isAttivo == true || e.AssociazioneId == this.userData.AssociazioneId;
          });
        } else if (this.userData.Role != this.ruoliUtente.UTENTE_AMMINISTRATIVO) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.isAttivo == true;
          });
        }

        if (filtro.Sezione) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.SezioneId == filtro.Sezione;
          });
        }
        if (filtro.TipoEvento) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.TipoEventoCodice == filtro.TipoEvento.Codice;
          });
        }

        if (this.userData.Role == this.ruoliUtente.ASSOCIATO) {
          if (filtro.isNotIscritto === false) {
            eventiFiltrati = eventiFiltrati.filter((e) => {
              return e.IsIscritto == true;
            });
          }
        }

        if (filtro.AnnoSportivo) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.AnnoSportivoId == filtro.AnnoSportivo.id;
          });
        }

        if (filtro.isIndoorOutdoor) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.isIndoor == (filtro.isIndoorOutdoor === 'Indoor' ? true : false);
          });
        }

        if (filtro.isAperti) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            const dataEvento = moment(e.DataEvento);
            return dataEvento.isSameOrAfter(moment(new Date()), 'day');
          });
        }
        Util.sortArrayByKey(eventiFiltrati, 'DataEvento');
        return eventiFiltrati;
      },

      changedMonth(d) {
        this.mese = new Date(d);
        this.eventiMese = this.filterEventi(this.mese, this.filtroEventi);
      },
      filtraTipoEvt(t) {
        if (t) {
          this.filtroEventi.TipoEvento = t;
        } else {
          this.filtroEventi.TipoEvento = null;
        }
        this.eventiMese = this.filterEventi(this.dataCalendario, this.filtroEventi);
      },
      filtraAnnoSez(i) {
        this.page = 1;
        this.filtroEventi.AnnoSportivo = i;
        this.refreshEvents(this);
        this.eventiMese = this.filterEventi(this.dataCalendario, this.filtroEventi);
      },

      filtraSez(s) {
        this.page = 1;
        this.filtroEventi.Sezione = s;
        this.eventiMese = this.filterEventi(this.mese, this.filtroEventi);
      },

      filtraIscritti(i) {
        this.page = 1;
        this.filtroEventi.isNotIscritto = i;
        this.eventiMese = this.filterEventi(this.mese, this.filtroEventi);
      },

      filtraTipoTag(i) {
        this.page = 1;
        this.filtroEventi.isIndoorOutdoor = i;
        this.eventiMese = this.filterEventi(this.mese, this.filtroEventi);
      },

      filtraAperti(i) {
        this.page = 1;
        this.eventiMese = this.filterEventi(this.dataCalendario, this.filtroEventi);
      },

      filtraGaraForDida(i) {
        this.page = 1;
        this.filtroEventi.isGara = i;
        this.filtroEventi.TipoEvento = null;
        this.eventiMese = this.filterEventi(this.dataCalendario, this.filtroEventi);
      },

      showPrenotazioneDialog(evt) {
        const vm = this;
        this.myEvtObj =  {
          idEvento: evt.id,
          idAnnoSportivo: this.filtroEventi.AnnoSportivo.id
        };
        if (evt.id) {
          evt.AnnoSportivoId = this.filtroEventi.AnnoSportivo.id
          this.loadPartecipazioni(this.myEvtObj).then(() => {
            vm.eventoObj = evt;
            vm.prenotazioneDialog = true;
          });
        }
      },

      showDettaglioDialog(evt) {
        const vm = this;
        this.loadImage(evt.id).then(() => {
          vm.eventoObj = evt;
          vm.dettaglioDialog = true;
        });
      },

      dialogAnnullamenoOpen(evt, x) {
        const vm = this;
        vm.eventoObj = evt;
        if (x === 0) {
          this.annullaItem = 'prenotazione';
          this.annullaText = 'la prenotazione';
        } else {
          this.annullaItem = 'iscrizione';
          this.annullaText = "l' iscrizione";
        }
        vm.dialogAnnullameno = true;
      },

      annullaPrenotazione(evt) {
        const vm = this;
        this.iscrizioneObj = {
          Id: evt.iscrizioneId,
          IdEvento: evt.id,
          StatoIscrizione: 'Annullato',
        };
        this.updatePartecipazione(this.iscrizioneObj).then(() => {
          vm.dialogAnnullameno = false;
          vm.refreshEvents(vm.mese.getMonth());
        });
      },

      checkFunzione(func) {
        return Security.isAbilitata(func, this.userData.Role);
      },

      isIscrittoFederazione(func) {
        return !this.userData.Open && this.userData.Role === this.ruoliUtente.ASSOCIATO;
      },

      isFiltroIscritto(func) {
        return this.userData.Role === this.ruoliUtente.ASSOCIATO;
      },

      showIscrivi(evt) {
        if (evt.TipologiaEvento === 'Didattico') {
          return (
            (evt.abilitatoPrenotazione || evt.abilitatoIscrizione) &&
            this.userData.AssociazioneId === evt.AssociazioneId.toString() &&
            this.checkFunzione(this.elencoFunzioni.ISCRIZIONE_EVENTO_ASSOCIAZIONE)
          );
        } else {
          return (evt.abilitatoPrenotazione || evt.abilitatoIscrizione) && this.checkFunzione(this.elencoFunzioni.ISCRIZIONE_EVENTO_ASSOCIAZIONE);
        }
      },

      showPrenota(evt) {
        let prenota = true;
        let open = true;
        if (evt.TipologiaEvento === 'Didattico' && this.userData.AssociazioneId != evt.AssociazioneId) {
          prenota = false;
        } else {
          open = evt.isOpen || (evt.isOpen == false && !this.userData.Open);
        }
        return (
          this.userData.tipoAccesso &&
          this.userData.tipoAccesso === 'WEB' &&
          prenota &&
          open &&
          evt.abilitatoPrenotazione &&
          this.userData.Role === this.ruoliUtente.ASSOCIATO &&
          this.checkFunzione(this.elencoFunzioni.INSERIMENTO_PRENOTAZIONE_EVENTO) &&
          !evt.IsIscritto
        );
      },

      showAnnulla(evt) {
        let retVal = false;
        if (evt && this.userData.tipoAccesso && this.userData.tipoAccesso == 'WEB') {
          const dataEvento = moment(evt.DataEvento);
          const dataAnnullamento = dataEvento.subtract(15, 'day');
          retVal = moment(new Date()).isSameOrBefore(dataAnnullamento);
        }
        return retVal;
      },

      downloadCsainPass() {
        if (this.userData.tipoAccesso && this.userData.tipoAccesso == 'WEB') {
          this.loadCsainPass(this.userData.id);
        } else if (this.userData.tipoAccesso && this.userData.tipoAccesso == 'APP') {
          this.downloadFromWebview('/associati/' + this.userData.id + '/arcopass');
        }
      },

      downloadCampionatoPass() {
        if (this.userData.tipoAccesso && this.userData.tipoAccesso == 'WEB') {
          this.loadCampionatoPass(this.userData.id);
        } else if (this.userData.tipoAccesso && this.userData.tipoAccesso == 'APP') {
          this.downloadFromWebview('/associati/' + this.userData.id + '/arcopassCampionato');
        }
      },

      filtraAnnuale(i) {
        this.page = 1;
        this.eventiMese = this.filterEventi(this.dataCalendario, this.filtroEventi);
      },
    },
  };
</script>

<style>
  .label-iscritto {
    border-bottom-left-radius: 5px;
    padding: 5px 10px;
    text-align: center;
    font-weight: bold;
    position: absolute;
    right: 0;
    top: 0;
  }
  .event-card {
    min-height: 200px;
  }

  .textR {
    text-align: right !important;
  }

  .switchEventi .v-input--switch__thumb {
    color: var(--v-accent-base) !important;
  }
  .switchEventi .v-input--switch__track {
    color: rgba(0, 0, 0, 0.38) !important;
  }
</style>
